export default __webpack_public_path__ + "static/media/V_Vassoura.04415d61.svg";